import { Controller } from "@hotwired/stimulus"

export default class ShowController extends Controller {
  handleFormSubmit(event: Event) {
    const target = event.target
    if (target instanceof HTMLFormElement) {
      const modalEl = target.closest(".modal")
      const modal = globalThis.bootstrap.Modal.getInstance(modalEl)
      if (modal) {
        modal.hide()
      } else {
        console.warn('Bootstrap modal instance not found')
      }
    }
  }

  handleProfileFormSubmit(event: CustomEvent) {
    if (event.detail.success) {
      // Turbo will re-render the frame, which will show view mode by default
      // The form submission was successful, so the page will be updated
    }
  }

  handleHidden() {
    const form = this.element.querySelector("form")
    if (form) {
      form.reset()
    }
  }
}
